import React from 'react'
import DatatableTables from './DatatableTables'

const ListInvoice = () => {
    return (
        <React.Fragment>
            {/* <div className="page-content"> */}
            {/* <Container fluid> */}
            {/* Render Breadcrumbs */}
            {/* <Breadcrumbs title="Setting" breadcrumbItem="Users" /> */}
            <DatatableTables />

            {/* </Container> */}
            {/* </div> */}
        </React.Fragment>
    )
}

export default ListInvoice
